var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateSignUpBenefits1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.743,
    height: 44.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4714",
    x: 0,
    y: 0,
    width: 43.743,
    height: 44.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4710",
    "data-name": "Rectangle 4710",
    width: 18.171,
    height: 19.686,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24417",
    "data-name": "Group 24417",
    transform: "translate(-73.531 -461)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 73.53, 461)",
    filter: "url(#Rectangle_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4714-2",
    "data-name": "Rectangle 4714",
    width: 25.743,
    height: 26.5,
    rx: 4,
    transform: "translate(9 6)",
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24404",
    "data-name": "Group 24404",
    transform: "translate(86.317 470.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24403",
    "data-name": "Group 24403",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46370",
    "data-name": "Path 46370",
    d: "M133.406,6.812A3.406,3.406,0,1,0,130,3.406a3.41,3.41,0,0,0,3.406,3.406m0-6.131a2.725,2.725,0,1,1-2.725,2.725A2.728,2.728,0,0,1,133.406.681",
    transform: "translate(-124.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46371",
    "data-name": "Path 46371",
    d: "M18.052,187.58H15.466a1.021,1.021,0,0,0,.042-.158l.031-.169,1.237-1.237a1.7,1.7,0,0,0,.423-1.7l-.707-2.3.131-.721a1.021,1.021,0,0,0-.71-1.16l-.457-1.487A3.748,3.748,0,0,0,11.874,176H6.007a3.747,3.747,0,0,0-3.581,2.645l-.457,1.487a1.021,1.021,0,0,0-.71,1.16l.131.721-.707,2.3a1.7,1.7,0,0,0,.423,1.7l1.237,1.237.031.168a1.022,1.022,0,0,0,.043.158H.341a.341.341,0,1,0,0,.681H18.052a.341.341,0,0,0,0-.681Zm-1.5-3.068a1.018,1.018,0,0,1-.254,1.022l-.541.541.474-2.607ZM6.007,176.681h5.868a3.05,3.05,0,0,1,2.93,2.164l.382,1.242H2.695l.382-1.242a3.05,3.05,0,0,1,2.93-2.164m-4.674,7.831.321-1.043.474,2.607-.541-.541a1.018,1.018,0,0,1-.254-1.023m2.045,3.068a.34.34,0,0,1-.335-.28l-.969-5.332v0l-.145-.8a.34.34,0,0,1,.318-.4H15.633a.34.34,0,0,1,.319.4h0l-.145.8v0l-.919,5.053h0v0l-.05.274a.34.34,0,0,1-.335.28H3.378Z",
    transform: "translate(0 -168.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46372",
    "data-name": "Path 46372",
    d: "M171.7,336a1.4,1.4,0,1,0,1.7,1.362A1.563,1.563,0,0,0,171.7,336m0,2.044c-.554,0-1.022-.312-1.022-.681s.468-.681,1.022-.681,1.022.312,1.022.681-.468.681-1.022.681",
    transform: "translate(-162.762 -321.695)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateSignUpBenefits1);
export default __webpack_public_path__ + "static/media/candidate-sign-up-benefits-1.df59c342328823c56ea2f40e4cb28f5c.svg";
export { ForwardRef as ReactComponent };